import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { Base64UploadComponent } from './Base64Upload.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'CargueArchivosGenerico',
        component: Base64UploadComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'CargueArchivosGenerico',
          nombreFormulario : 'Cargue Archivos Generico'
        } 
    }
];

@NgModule({
    declarations: [
        Base64UploadComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        Base64UploadComponent
    ],
    bootstrap: [Base64UploadComponent]
})

export class CargueArchivosGenericoModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/CargueArchivosGenerico/CargueArchivosGenerico.module.ts